export default __webpack_public_path__ + "static/media/support.33e9bb0a.svg";